import * as React from 'react';
import Grid from '@mui/material/Grid2';
import TextFieldComponent from '../../../components/form/TextFieldComponent';
import AddIcon from '@mui/icons-material/Add';
import DeleteForeverIcon from '@mui/icons-material/Delete';
import EditNoteIcon from '@mui/icons-material/EditNote';
import {
  Box,
  Button,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from '@mui/material';

interface ResourcesViewProps {
  handleResourceDialog: (open: boolean) => void;
  viewOnly: boolean;
  resourceItems: any[];
  shiftStatusId: number;
  inputRefs: any;
  editNoteDialog: (index: number) => void;
  handleResourceChange: (value: any, index: number, type: any) => void;
  removeItem: (index: number) => void;
}
const ResourcesView: React.FC<ResourcesViewProps> = ({
  viewOnly,
  resourceItems,
  handleResourceDialog,
  shiftStatusId,
  editNoteDialog,
  handleResourceChange,
  removeItem,
  inputRefs,
}) => {
  const getInputKey = (field: any, index: any) => `${field}_${index}`;
  return (
    <Grid size={12} sx={{ gap: 20, marginTop: '35px' }}>
      {(shiftStatusId === 0 || shiftStatusId === 2) && (
        <Button
          variant="outlined"
          startIcon={<AddIcon />}
          className="primarybtn"
          onClick={() => {
            handleResourceDialog(true);
          }}
        >
          Add Resource
        </Button>
      )}
      {resourceItems.length > 0 && (
        <TableContainer sx={{ mt: 2 }} component={Paper}>
          <Table className="">
            <TableRow
              className="headrowtbl"
              key={'headrow_'}
              style={{ background: ' rgba(0, 244, 255, 0.06)' }}
            >
              <TableCell key={'tblheadcllitemc_'} className="boldfont">
                Resource Item
              </TableCell>
              <TableCell
                key={'tblbotblheadclliqty_'}
                className="boldfont"
                style={{ width: '100px' }}
              >
                Plan Quantity
              </TableCell>
              <TableCell
                key={'tblbotblheadcllistarttime_'}
                className="boldfont"
                style={{ width: '' }}
              >
                Plan StartTime
              </TableCell>
              <TableCell
                key={'tblbotblheadclliendtime_'}
                className="boldfont"
                style={{ width: '' }}
              >
                Plan EndTime
              </TableCell>
              <TableCell
                key={'tblbotblheadclliplntotaltime_'}
                className="boldfont"
                sx={borderStyleRight}
              >
                Plan TotalTime
              </TableCell>
              <TableCell className="boldfont" style={{ width: '150px' }}>
                Actual Quantity
              </TableCell>
              <TableCell className="boldfont" style={{ width: '150px' }}>
                Actual Start Time
              </TableCell>
              <TableCell className="boldfont" style={{ width: '150px' }}>
                Actual End Time
              </TableCell>
              <TableCell
                className="boldfont"
                style={{ width: '150px' }}
                sx={borderStyleRight}
              >
                Actual Total Time
              </TableCell>
              <TableCell
                key={'tblheadcluom_'}
                className="boldfont"
                style={{ width: '100px' }}
              >
                Review Quantity
              </TableCell>
              <TableCell
                key={'tblbotblheadclliqtyreviewsstarttime_'}
                className="boldfont"
                style={{ width: '' }}
              >
                Review StartTime
              </TableCell>
              <TableCell
                key={'tblbotblheadcllireviewendtime_'}
                className="boldfont"
                style={{ width: '' }}
              >
                Review EndTime
              </TableCell>
              <TableCell
                colSpan={2}
                key={'tblbotblheadcllireviewttltime_'}
                className="boldfont"
                style={{ width: '' }}
              >
                Review TotalTime
              </TableCell>
            </TableRow>
            {resourceItems.map((item: any, index: any) => {
              return (
                <TableBody key={'tblbody_' + index}>
                  <TableRow key={'bodyrow_dtl_' + index + '_'}>
                    <TableCell key={'bodyrow_dtl_cell_name-' + index + '_'}>
                      {item.name}
                    </TableCell>
                    <TableCell key={'bodyrow_dtl_plan_qty-' + index + '_'}>
                      {shiftStatusId === 0 && (
                        <TextFieldComponent
                          inputRef={(el: any) => {
                            inputRefs.current[
                              getInputKey('planQuantity', index)
                            ] = el;
                          }}
                          label=""
                          keyName={'qtyFormBillable_plan_' + index}
                          name={'qtyFormBillable_plan_' + index}
                          value={item.planQuantity}
                          onChange={(event) => {
                            handleResourceChange(
                              event.target.value,
                              index,
                              'planQuantity'
                            );
                          }}
                          errorStr={''}
                          type="number"
                          isRequired={false}
                          style={{ width: '120px' }}
                        />
                      )}
                      {shiftStatusId !== 0 && (
                        <Box sx={boxStyle}>{item.planQuantity}</Box>
                      )}
                    </TableCell>
                    <TableCell
                      key={'bodyrow_dtl_plan_startimetxt-' + index + '_'}
                    >
                      {shiftStatusId === 0 && (
                        <TextFieldComponent
                          label=""
                          keyName={'FormBillable_plan_start_time' + index}
                          name={'FormBillable_plan_start_time' + index}
                          value={item.planStartTime}
                          onChange={(event) => {
                            handleResourceChange(
                              event.target.value,
                              index,
                              'planStartTime'
                            );
                          }}
                          errorStr={''}
                          type="time"
                          isRequired={false}
                        />
                      )}
                      {shiftStatusId !== 0 && (
                        <Box sx={boxStyle}>{item.planStartTime}</Box>
                      )}
                    </TableCell>
                    <TableCell
                      key={'bodyrow_dtl_plan_endimetxt-' + index + '_'}
                    >
                      {shiftStatusId === 0 && (
                        <TextFieldComponent
                          label=""
                          keyName={'FormBillable_plan_end_time' + index}
                          name={'FormBillable_plan_end_time' + index}
                          value={item.planEndTime}
                          onChange={(event) => {
                            handleResourceChange(
                              event.target.value,
                              index,
                              'planEndTime'
                            );
                          }}
                          errorStr={''}
                          type="time"
                          isRequired={false}
                        />
                      )}
                      {shiftStatusId !== 0 && (
                        <Box sx={boxStyle}>{item.planEndTime}</Box>
                      )}
                    </TableCell>
                    <TableCell
                      key={'bodyrow_dtl_plan_total_timetxt-' + index + '_'}
                      sx={borderStyleRight}
                    >
                      {viewOnly === false && (
                        <Box sx={boxStyle}>{item.planTotalTime}</Box>
                      )}
                      {shiftStatusId === 0 && (
                        <IconButton
                          aria-label="EditNote"
                          onClick={() => {
                            editNoteDialog(index);
                          }}
                          sx={boxStyle}
                        >
                          <EditNoteIcon
                            sx={{
                              color: item.notes ? '#00e5ff' : '#000',
                            }}
                          />
                        </IconButton>
                      )}
                    </TableCell>
                    <TableCell>
                      <Box sx={boxStyle}>
                        {item.actualQuantity || shiftStatusId === 2
                          ? item.actualQuantity
                          : '-'}
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Box sx={boxStyle}>
                        {item.actualStartTime || shiftStatusId === 2
                          ? item.actualStartTime
                          : '-'}
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Box sx={boxStyle}>
                        {item.actualEndTime || shiftStatusId === 2
                          ? item.actualEndTime
                          : '-'}
                      </Box>
                    </TableCell>
                    <TableCell sx={borderStyleRight}>
                      <Box sx={boxStyle}>
                        {(item.actualTotalTime &&
                          item.actualTotalTime != '00:00:00') ||
                        shiftStatusId === 2
                          ? item.actualTotalTime
                          : '-'}
                      </Box>
                    </TableCell>
                    <TableCell
                      key={'bodyrow_dtl_cell_reviewQty-' + index + '_'}
                    >
                      {(shiftStatusId === 2 || shiftStatusId === 3) && (
                        <TextFieldComponent
                          label=""
                          inputRef={(el: any) => {
                            inputRefs.current[
                              getInputKey('reviewQuantity', index)
                            ] = el;
                          }}
                          keyName={'costFormBillable_review_qty_' + index}
                          name={'costFormBillable_review_qty_' + index}
                          value={item.reviewQuantity ? item.reviewQuantity : ''}
                          onChange={(event: any) => {
                            handleResourceChange(
                              event.target.value,
                              index,
                              'reviewQuantity'
                            );
                          }}
                          errorStr={''}
                          type="number"
                          isRequired={false}
                          style={{ width: '120px' }}
                        />
                      )}
                      {shiftStatusId !== 2 && shiftStatusId !== 3 && (
                        <Box sx={boxStyle}>
                          {item.reviewQuantity ? item.reviewQuantity : '-'}
                        </Box>
                      )}
                    </TableCell>
                    <TableCell>
                      {(shiftStatusId === 2 || shiftStatusId === 3) && (
                        <TextFieldComponent
                          label=""
                          keyName={'FormBillable_review_start_time' + index}
                          name={'FormBillable_review_start_time' + index}
                          value={
                            item.reviewStartTime === '00:00' &&
                            item.reviewEndTime === '00:00'
                              ? ''
                              : item.reviewStartTime
                          }
                          onChange={(event) => {
                            handleResourceChange(
                              event.target.value,
                              index,
                              'reviewStartTime'
                            );
                          }}
                          errorStr={''}
                          type="time"
                          isRequired={false}
                        />
                      )}
                      {shiftStatusId !== 2 && shiftStatusId !== 3 && (
                        <Box sx={boxStyle}>
                          {item.reviewStartTime &&
                          item.reviewStartTime !== '00:00'
                            ? item.reviewStartTime
                            : '-'}
                        </Box>
                      )}
                    </TableCell>
                    <TableCell>
                      {(shiftStatusId === 2 || shiftStatusId === 3) && (
                        <TextFieldComponent
                          label=""
                          keyName={'FormBillable_review_end_time' + index}
                          name={'FormBillable_review_end_time' + index}
                          value={
                            item.reviewStartTime === '00:00' &&
                            item.reviewEndTime === '00:00'
                              ? ''
                              : item.reviewEndTime
                          }
                          onChange={(event) => {
                            handleResourceChange(
                              event.target.value,
                              index,
                              'reviewEndTime'
                            );
                          }}
                          errorStr={''}
                          type="time"
                          isRequired={false}
                        />
                      )}
                      {shiftStatusId !== 2 && shiftStatusId !== 3 && (
                        <Box sx={boxStyle}>
                          {item.reviewEndTime && item.reviewEndTime != '00:00'
                            ? item.reviewEndTime
                            : '-'}
                        </Box>
                      )}
                    </TableCell>
                    <TableCell>
                      <Box sx={boxStyle}>
                        {item.reviewTotalTime &&
                        item.reviewTotalTime != '00:00:00'
                          ? item.reviewTotalTime
                          : '-'}
                      </Box>
                    </TableCell>
                    {
                      <TableCell style={{ width: '100px' }}>
                        {((shiftStatusId === 2 && !item.shiftResourceId) ||
                          shiftStatusId === 0) && (
                          <IconButton
                            key={'bodyrow_dtl_cell_delet-icn-' + index + '_'}
                            aria-label="delete"
                            onClick={() => {
                              removeItem(index);
                            }}
                            sx={boxStyle}
                          >
                            <DeleteForeverIcon />
                          </IconButton>
                        )}
                        {(shiftStatusId === 2 || shiftStatusId === 3) && (
                          <IconButton
                            aria-label="delete"
                            onClick={() => {
                              editNoteDialog(index);
                            }}
                            sx={boxStyle}
                          >
                            <EditNoteIcon
                              sx={{
                                color: item.notes ? '#00e5ff' : '#000',
                              }}
                            />
                          </IconButton>
                        )}
                      </TableCell>
                    }
                  </TableRow>
                </TableBody>
              );
            })}

            {/* </TableBody> */}
          </Table>
        </TableContainer>
      )}
    </Grid>
  );
};
export default ResourcesView;
const boxStyle = {
  marginBottom: '15px',
};

const borderStyleRight = {
  borderRight: '1px solid #edeeed',
};
